import axios from 'axios'
import { ActionContext } from '@/utils/interfaces'

export const mutations = {
  reloadCashier (state: any): void {
    state.reloadCashier++
  },
  setConfigs (state: any, payload: object): void {
    state.config = payload
    state.reloadCashier++
  },
  setTheme (state: any, payload: object): void {
    state.theme = payload
    state.reloadCashier++
  },
  setCustomCss (state: any, css: string): void {
    state.customCss = css
    state.reloadCashier++
  },
  setAutoProcessProvider (state: any, provider: string) {
    state.autoProcessProvider = provider
  },
  setCashierSpinner (state: any, payload: string) {
    state.cashierSpinner = payload
  },
  setExtraConfigs (state: any, payload: object) {
    state.extraConfigs = payload
  },
  setExtraCustomCSS (state: any, css: string) {
    state.extraCustomCSS = css
  },
  setCashierType (state: any, type: string) {
    state.cashierType = type
  },
  setCheckoutClient (state: any, boo: boolean) {
    state.checkoutClient = boo
  }
}

export const actions = {
  setConfigs ({ commit, state }: ActionContext, payload: object): void {
    const inheritBasicConfigs = {
      merchantId: state.config.merchantId,
      userId: state.config.userId,
      sessionId: state.config.sessionId,
      environment: state.config.environment,
      predefinedAmounts: state.config.predefinedAmounts,
      method: state.config.method,
      showFee: state.config.showFee,
      showAmountLimits: state.config.showAmountLimits,
      pmListLimit: 10
    }
    const newConfigs: object = {
      ...inheritBasicConfigs,
      ...payload
    }
    commit('setConfigs', newConfigs)
  },
  reloadCashier ({ dispatch, state }: ActionContext, payload: any): void {
    const newConfigs: object = {
      ...state.config,
      ...payload && payload,
      autoProcess: false,
      providerType: null
    }
    dispatch('setConfigs', newConfigs)
  },
  setTheme ({ commit, state }: ActionContext, payload: object): void {
    const newTheme: object = {
      ...state.theme,
      ...payload
    }
    commit('setTheme', newTheme)
  },
  async fetchUserKYC ({ commit, dispatch }: ActionContext, payload: any) {
    // Fetch KYC from PIQ using codes in payload
    const { data, basicAuth } = payload
    console.log(data)
    console.log(basicAuth)
    try {
      const response = await axios.request({
        method: 'POST',
        url: `https://test-api.paymentiq.io/paymentiq/oauth/token?grant_type=authorization_code&code=${data.code}&redirect_uri=https://pay.paymentiq.io`,
        headers: {
          Authorization: basicAuth // base64 api-client:clientSecret of simon-1click
        }
      })
      console.log(response)
      const userInfo = {
        isAuth: true,
        email: response.data.email,
        username: response.data.name
      }
      dispatch('loginUser', userInfo)
    } catch (err) {
      console.error(err)
    }
  }
}
